import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const Triage = props => {
  const { classes } = props;
  return (
    <div>
      <Typography color="primary" variant="h5">Triage</Typography>
      {/* <Typography className={classes.para} paragraph> */}
      <ul>
        <li>
          <Typography className={classes.para}>
            Those who are likely to live, regardless of what care they receive;
          </Typography>
        </li>
        <li>
          <Typography className={classes.para}>
            Those who are unlikely to live, regardless of what care they
            receive;
          </Typography>
        </li>
        <li>
          <Typography className={classes.para}>
            Those for whom immediate care might make a positive difference in
            outcome.
          </Typography>
        </li>
      </ul>
      <Typography className={classes.para}>
        I find this framework useful while allocating my time to different tasks
        such as research, exploration, documentation and issues involved in
        specific assignments. Especially when I'm lagging in behind.
        <br />I try not to overdo some week's work and under perform in other.
      </Typography>
      {/* </Typography> */}
    </div>
  );
};

export default withStyles(styles)(Triage);
